module.exports = __webpack_public_path__ + "static/media/cash-register.5ab61d05.svg";